export default "__VITE_ASSET__CGAP$3og__"